export default {
    BILLABLE: { entity: 'modal.update_organization.billable_options.true', name: true },
    NOT_BILLABLE: { entity: 'modal.update_organization.billable_options.false', name: false }
};